export const authRoles = {
  sa: ["SA"], // Only Super Admin has access
  admin: ["SA", "ADMIN"], // Only SA & Admin has access
  editor: ["SA", "ADMIN", "EDITOR"], // Only SA & Admin & Editor has access
  guest: ["SA", "ADMIN", "EDITOR", "GUEST"], // Everyone has access
};

// Check out app/views/resources/ResourcesRoutes.js
// Only SA & Admin has resources access

// const resourcesRoutes = [
//   {
//     path: "/resources",
//     component: Resources,
//     auth: authRoles.admin <----------------
//   }
// ];
